<template>
    <section id="marinaMap"  class="relative h-[67vh] z-[1] will-change" :data-scroll-section="inner == 'false'">
        <div class="mx-content h-full">
            <!-- <div class=""> -->
                <!-- <p class="leading-none mb-7 uppercase tracking-desk" v-show="blockData.text" v-html="blockData.text"></p> -->
                <h2 class="text-4xl xl:text-title text-center tracking-[2px] leading-none text-white px-8 absolute top-8 xl:top-16 w-full z-10" v-show="blockData.title">{{ blockData.title }}</h2>
            <!-- </div> -->

            <div class="flex items-center " ref="popup">
                <div v-if="activePoint">
                    <img :src="activePoint.poi[0].fields.image.url" :alt="activePoint.poi[0].fields.image.alt"/>
                    <h4 class="font-ginger text-sm text-navy-blue-01 font-bold leading-snug mb-1 mt-3"  v-html="activePoint.poi[0].post_title"></h4>
                    <div class="mr-1 text-xs py-[5px] text-navy-blue-03"  v-html="activePoint.poi[0].store_neighbourhood.name"></div>
                    <div class="flex items-center border-t border-light-grey text-xs text-dark-grey cursor-pointer py-[10px]" @click.stop.prevent="showPOISlide()">{{__('Show more info', 'ccave')}}
                        <svg class="ml-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 3L11 8L6 13" stroke="#BFBFBF" stroke-width="1.2" stroke-linecap="square"/>
                        </svg>
                    </div>
                </div>
            </div>

            <!-- map -->
            <div id="map" class="rounded-lg" style="height: 100%;"></div>
            <!-- map -->

            <div class="px-content flex items-center justify-center text-white absolute bottom-10 xl:bottom-16 w-full z-10">
                <div class="flex xl:w-4/12 ml-auto" v-if="blockData.text">
                    <div class="text-sm xl:w-[90%]" v-show="blockData.text" v-html="blockData.text"></div>
                </div>

            </div>
        </div>

        <div class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
			<span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
		</div>



        <div :class="{ 'xyz-in z-[51] active-card': showSlide, 'xyz-out z-[40]': !showSlide }"
                 class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] overflow-y-auto invisible scroll-just-this"  
                 xyz="fade right-100% duration-4" ref="slideCard" data-scroll data-scroll-sticky data-scroll-target="#marinaMap"
                 v-on-clickaway="clickAwaySlide">
                <button type="button" @click="hidePOISlide()" class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-6 top-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
                <div v-if="activePoint">
                    <img class="object-cover w-full" :src="activePoint.poi[0].fields.image.sizes.customslide" :alt="activePoint.poi[0].fields.image.alt">
                    <div class="p-8">
                        <h4 class="text-2xl tracking-[1px] mb-6" >{{ activePoint.poi[0].post_title }}</h4>
                        <div class="text-sm" v-show="activePoint.poi[0].fields.text" v-html="activePoint.poi[0].fields.text"></div>
                    </div>
                </div>
        </div>
    </section>
</template>


<script>
import mapboxgl from 'mapbox-gl'
import "mapbox-gl/dist/mapbox-gl.css"
import centerOfMass from '@turf/center-of-mass'
import { mixin as clickaway } from 'vue-clickaway'
    export default {
        name: 'MarinaMap',
        mixins: [ clickaway ],
        data() {
            return {
                map: false,
                popup: false,
                activePoint: false,
                showSlide: false,
            }
        },
        mounted() {
            mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
            this.map = new mapboxgl.Map({
                container: 'map', // container ID
                /* style: this.blockData.map.map_settings.style, */ // style URL
                style: 'mapbox://styles/aleksandarstojsin/ckvqeuf2qo9iz15mp3rysmrpd',
                center: this.blockData.map.map_settings.center, // starting position
                zoom: this.blockData.map.map_settings.zoom, // starting zoom
                pitch: this.blockData.map.map_settings.pitch,
                bearing: this.blockData.map.map_settings.bearing,
                cooperativeGestures: true,
                attributionControl: false
            });

            this.popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: true,
                /* offset: [0, -15] */
            });

            this.map.on('load', () => {
                this.blockData.map.markers.forEach((marker, index) => {
                    let mapData = JSON.parse(marker.map_data)
                     if ( mapData.geometry.type === 'Polygon' ) {
                        this.map.addSource('polygon'+index, {
                            'type': 'geojson',
                            'data': mapData
                        })

                        this.map.addLayer({
                            'id': 'fill'+index,
                            'type': 'fill',
                            'source': 'polygon'+index,
                            'layout': {},
                            'paint': {
                                'fill-color': '#0080ff', // mora boja i opacity na nula da bi bilo transparentno, amozda moze i drugacije
                                'fill-opacity': 0
                            }
                        });

                        this.map.addLayer({
                            'id': 'outline'+index,
                            'type': 'line',
                            'source': 'polygon'+index,
                            'layout': {},
                            'paint': {
                                'line-color': '#FFF',
                                'line-width': 0
                            }
                        });
                        var comPt = centerOfMass(mapData);

                        this.map.addSource('label'+index, {
                            'type': 'geojson',
                            'data': comPt
                        });

                        this.map.addLayer({
                            'id': 'label-style'+index,
                            'type': 'symbol',
                            'source': 'label'+index,
                            'layout': {
                                'text-field': marker.name,

                            },
                            'paint': {
                                'text-color': 'white'
                            }
                        });

                    } else {
                        this.map.loadImage(
                            this.endpoints.template_url + '/assets/img/dot-circle-white.png',
                            (error, image) => {
                                if (error) throw error;
                                this.map.addImage('custom-marker'+index, image);
                                // Add a GeoJSON source with 2 points
                                this.map.addSource('points'+index, {
                                    'type': 'geojson',
                                    'data': mapData
                                });

                                // Add a symbol layer
                                this.map.addLayer({
                                    'id': 'points'+index,
                                    'type': 'symbol',
                                    'source': 'points'+index,
                                    'layout': {
                                        'icon-image': 'custom-marker'+index,
                                        "icon-allow-overlap": true,
                                    },
                                });

                                /* this.map.on('mousemove', 'points'+index, (e) => {
                                    this.map.getCanvas().style.cursor = 'pointer';
                                    this.activePoint = this.blockData.map.markers[index]
                                    if ( this.$refs.slideCard.classList.contains('invisible') && !this.showSlide ) {
                                        this.$refs.slideCard.style.visibility = 'visible'
                                        this.showSlide = true
                                    }
                                }); */

                                this.map.on("click", "points" + index, e => {
                                    this.map.getCanvas().style.cursor = "pointer";
                                    /* this.map.setLayoutProperty('points'+index, 'icon-image', "custom-marker-hover" + index); */
                                        this.activePoint = marker
                                        /* this.activeMenuCategory = this.categories.filter( cat => {
                                            return cat.id === marker.store[0].store_categories[0].term_id })
                                        this.showMenuCategory(marker.store[0].store_categories[0].term_id) */
                                        this.showSlide = false
                                        this.popup
                                            .setLngLat(e.lngLat)
                                            .setDOMContent(this.$refs.popup)
                                            .addTo(this.map);
                                });

                                /* map.on('mouseleave', 'points'+index, () => {
                                    map.getCanvas().style.cursor = '';
                                    this.showSlide = false
                                }); */
                            }
                        );
                    }


                });
            })
            this.map.addControl(new mapboxgl.NavigationControl());
            this.map.scrollZoom.disable();

            /* this.$refs.slideCard.addEventListener('mouseenter', (e) => {
                this.$root.scroll.stop()
            })
            this.$refs.slideCard.addEventListener('mouseleave', (e) => {
                this.$root.scroll.start()
            }) */

        },
        watch: {
		    showSlide: function (val) {	if( val ) { this.$root.scroll.stop() } else { this.$root.scroll.start()	} }
	    },
        methods: {
            clickAwaySlide() {
			    this.showSlide = false
		    },
            showPOISlide(){
                if ( this.$refs.slideCard.classList.contains('invisible') && !this.showSlide ) {
                    this.$refs.slideCard.style.visibility = 'visible'
                    this.showSlide = true
                    this.popup.remove()

                    let offsetCard
                    if ( this.$root.isMobile ){
                        offsetCard = -67 
                    } else{
                        offsetCard = -116 
                    }

                    this.$root.scroll.scrollTo('#marinaMap', {
                        offset: offsetCard,
                        duration: 800,
                        disableLerp: true
                    })

                    /* this.$nextTick( ()=>{ this.slideSlider = new Swiper( this.$refs.slideSlider, this.slideSliderOptions ) } ) */

                }
            },
            hidePOISlide() {
                setTimeout(() => {
                    this.$refs.slideCard.style.visibility = 'hidden'
                }, 500);
                this.showSlide = false
            }
        },
    }
</script>
